import { get } from '@helpcenter/ajax';
import type { Observable } from '@helpcenter/epics-rxjs';
import { getMeta } from '@helpcenter/meta';
import * as qs from 'query-string';
import { APOLLO_STARGATE_CONTEXT_ROOT } from 'rest/constants';
import type { KnowledgeBaseSearchResult as FormattedKnowledgeBaseSearchResult } from 'state/ui/search';
import FeatureGates from '@atlaskit/feature-gate-js-client';
import type { KnowledgeBaseSearchResponse, KnowledgeArticleResponse, KbsQuery } from './types';

export const searchKbs = (kbsQuery: KbsQuery): Observable<FormattedKnowledgeBaseSearchResult> => {
    const { projectId, query, resultLimit, expandPortalName, categoryIds, portalIds, labels, requestTypeId } = kbsQuery;
    const queryParams = {
        labels,
        portalIds,
        categoryIds,
        searchQuery: query,
        limit: resultLimit,
        expand: expandPortalName ? 'portal' : undefined,
    };

    const queryString = qs.stringify(queryParams);
    let uri;
    const activationId = getMeta('activation-id') as string;
    if (projectId) {
        if (FeatureGates.checkGate('remove-linked-spaces-check-for-article-suggestions') && requestTypeId) {
            uri = `${APOLLO_STARGATE_CONTEXT_ROOT}/${activationId}/api/jsm-portal/project/${projectId}/request-type/${requestTypeId}/articles?${queryString}`;
        } else {
            uri = `${APOLLO_STARGATE_CONTEXT_ROOT}/${activationId}/api/jsm-portal/project/${projectId}/articles?${queryString}`;
        }
    } else {
        uri = `${APOLLO_STARGATE_CONTEXT_ROOT}/${activationId}/api/jsm-portal/articles?${queryString}`;
    }

    return get(uri, { 'Content-Type': 'application/json' }).map((ajaxResponse) => {
        const result = ajaxResponse.response as KnowledgeBaseSearchResponse;
        return {
            ...result,
            articles: result.articles.map((article: KnowledgeArticleResponse) => ({
                id: article.articleId,
                name: article.articleTitle,
                articleSnippet: article.articleSnippet,
                pageVersion: article.articleVersion,
                score: article.snippetScore,
                isSmartSnippet: article.isSmartSnippet,
                linkedPortals: article.linkedPortals,
                sourceType: article.articleSource,
                articleUrl: article.articleUrl,
            })),
        };
    });
};
